module.exports = __webpack_public_path__ + "static/media/Buzzer_4_EpicaLDC_Janosch.9c397871.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/Buzzer_4_EpicaLDC_Janosch.mp3
// module id = 287
// module chunks = 0